import Ckzjzy from './ckzjzy'
import pbzb from './pbzb'
import pbbg from './pbbg'

import Pbwyh from './pbwyh'
export default {
    path: 'pingbiao',
    component: () => import(/*webpackChunkName: 'bidding-pingbiao'*/ '@layout/empty'),
    children: [
        Ckzjzy,
        pbzb,
        Pbwyh,
        pbbg,
    ]
}